import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8.525 5.35a3.475 3.475 0 1 1 6.95 0V12a3.475 3.475 0 1 1-6.95 0V5.35ZM12 3.125A2.225 2.225 0 0 0 9.775 5.35V12a2.225 2.225 0 0 0 4.45 0V5.35A2.225 2.225 0 0 0 12 3.125Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.35 9.475c.345 0 .625.28.625.625V12a6.025 6.025 0 0 0 12.05 0v-1.9a.625.625 0 1 1 1.25 0V12a7.276 7.276 0 0 1-6.65 7.248v1.627H15.8a.625.625 0 1 1 0 1.25H8.2a.625.625 0 1 1 0-1.25h3.175v-1.627A7.276 7.276 0 0 1 4.725 12v-1.9c0-.345.28-.625.625-.625Z"
    />
  </svg>
`;
